export default {
  courseList: [],
  courseTypeList: []
}
